
import { Vue } from "vue-class-component";

export default class Airplane extends Vue {}
